import moment from 'moment';
import $ from 'jquery';
import isTouchDev from './isTouchDev';
import 'moment/locale/sv';

class Calendar {
    constructor(selected,$lineWidth,qty,$line,$dayWidth,step,$monthSelect,$eventsListWrapper,$noEventsMessage,$loading) {
        this.selectedDate = selected;
        this.selectedMonth = moment(selected).format('YYYY-MM');
        this.line = [];
        this.$dayWidth = $dayWidth;
        this.$line = $line;
        this.step = step;
        this.$lineWidth = $lineWidth;
        this.qty = qty;
        this.$monthSelect = $monthSelect;
        this.isMoving = false;
        this.isFetching = false;
        this._startLineDateMoment = {};
        this._months = [];
        this.start_events_date = '';
        this.end_events_date = '';
        this.$eventsListWrapper = $eventsListWrapper;
        this.$noEventsMessage = $noEventsMessage;
        this.$loading = $loading;
        this.events = [];
        this.permanentEvents = [];
        this.selectedCategory = {name:'all', permanent:false};
        this.availableDates = [];
    }

    setSelectedDate(date) {
        if(!this.isFetching) {
            this.selectedDate = moment(date);
            this._selectDayInLine(date);
            this.buildLine();
            this.selectedMonth = this.selectedDate.format('YYYY-MM');
            this.buildMonthsOptions();
            this._sendDates();
        }
    }

    selectMonth(month) {
        if(!this.isFetching) {
            this.selectedDate = moment(month);
            this.selectedMonth = this.selectedDate.format('YYYY-MM');
            this.line = [];
            this.generateInitDays();
            this.buildLine();
            this.buildMonthsOptions();
            this._sendDates();
        }
    }

    setCategory(category) {
        this.selectedCategory = category;
    }

    selectCategory(category) {
        this.selectedCategory = category;
        this.$eventsListWrapper.empty();
        this._showNoEventsMessage(false);
        this._parseEvents();
    }

    // setters
    setLineWidth(width) {
        this.$lineWidth = width;
        this.resetLineWidth();
    }
    setStep(step) {
        this.step = step;
    }
    setQty(qty) {
        this.qty = qty;
    }

    _generatePrevDates() {
        this._startLineDateMoment = moment(this.line[0].date);
        const startLineDate = this._startLineDateMoment;
        const selectedDate = this.selectedDate.format('YYYY-MM-DD');

        for(let i = 1; i<=this.step; i++) {
            const newDate = moment(startLineDate).add(-i,'days').format('YYYY-MM-DD');
            const prevDay = moment(newDate).add(-1, 'days');
            const nextDay = moment(newDate).add(1, 'days');
            this.line.unshift({
                inactive: !this.availableDates.some(date => date === newDate),
                selected: selectedDate === newDate,
                date: newDate,
                dayName:  moment(newDate).format('ddd'),
                day:  moment(newDate).format('DD'),
                month: moment(newDate).format('MMM'),
                showMonth: moment(newDate).format('MMM') !== prevDay.format('MMM') || moment(newDate).format('MMM') !== nextDay.format('MMM'),
            })
        }
    }

    _generateNextDates() {
        const selectedDate = this.selectedDate.format('YYYY-MM-DD');
        const lastLineDate = moment(this.line[this.line.length-1].date);
        for(let i = 1; i<=this.step; i++) {
            const newDate = moment(lastLineDate).add(i,'days').format('YYYY-MM-DD');
            const prevDay = moment(newDate).add(-1, 'days');
            const nextDay = moment(newDate).add(1, 'days');
            this.line.push({
                inactive: !this.availableDates.some(date => date === newDate),
                selected: selectedDate === newDate,
                date: newDate,
                dayName:  moment(newDate).format('ddd'),
                day:  moment(newDate).format('DD'),
                month: moment(newDate).format('MMM'),
                showMonth: moment(newDate).format('MMM') !== prevDay.format('MMM') || moment(newDate).format('MMM') !== nextDay.format('MMM'),
            })
        }
    }

    init() {
        this._getPermanentEvents();
        this._getAvailableDates().then(range=>{
            this._sortDates(range);
            this.start_events_date = range[0];
            this.end_events_date = range[range.length-1];
            let ranges = [];
            for (let key in range) {
                ranges.push(range[key])
            }
            this.availableDates = ranges;
            this.generateInitDays();
            this.generateInitMonths();
            this.buildLine();
        },error=>{
            console.warn(error)
        })
    }

    _getAvailableDates() {
        return new Promise((resolve,reject)=>{
            $.ajax({
                type : "GET",
                dataType : "json",
                url: window.ajaxurl,
                data: ({
                    action: 'available_events_action',
                }),
                success: (res)=>{
                    resolve(res.range);
                },
                error: (error) => {
                    reject(error)
                },
            });
        })
    }

    generateInitDays() {
        this.line = [];
        const selectedDate = this.selectedDate.format('YYYY-MM-DD');
        this._startLineDateMoment = moment(selectedDate).add(-1, 'days');
        const startLineDate = this._startLineDateMoment.format('YYYY-MM-DD');
        for(let i = 0; i<this.qty; i++) {
            const newDate = moment(startLineDate).add(i,'days').format('YYYY-MM-DD');
            const prevDay = moment(newDate).add(-1, 'days');
            const nextDay = moment(newDate).add(1, 'days');
            this.line.push({
                inactive: !this.availableDates.some(date => date === newDate),
                selected: selectedDate === newDate,
                date: newDate,
                dayName:  moment(newDate).format('ddd'),
                day:  moment(newDate).format('DD'),
                month: moment(newDate).format('MMM'),
                showMonth: moment(newDate).format('MMM') !== prevDay.format('MMM') || moment(newDate).format('MMM') !== nextDay.format('MMM'),
            })
        }
    }

    generateInitMonths() {
        const startDateMoment = moment(this.start_events_date);
        const endDateMoment = moment(this.end_events_date);

        // reset month array
        this._months = [];

        while (endDateMoment.diff(startDateMoment,'days') > 0 || startDateMoment.format('M') === endDateMoment.format('M')) {
            this._months.push(startDateMoment.format('YYYY-MM'));
            startDateMoment.add(1,'month');
        }
        this.buildMonthsOptions();
        this._sendDates();
    }

    _selectDayInLine(date) {
        this.line = this.line.map(day=>{
            if(day.date === date) {
                return {...day, selected:true};
            }
            return {...day, selected:false};
        });
    }

    buildLine() {
        this.resetLineWidth();
        this.$line.empty();
        this.line.forEach(day=>{
            let className = day.selected ? 'selected' : '';
            let inactiveClass = day.inactive ? 'inactive' : '';
            let month = day.showMonth ? day.month : '&nbsp;';
            this.$line.append('<li class="day ' + className + '"><div class="month-label">' + month + '</div><a href="#'+ day.date +'" class="js-select-date ' + className + ' ' + inactiveClass + '" data-date="' + day.date + '"><span class="day-label">' + day.day + '</span><span class="day-name-label">' + day.dayName + '</span></a></li>');
        });
    }

    buildMonthsOptions() {
        this.$monthSelect.empty();
        this._months.forEach(month=>{
            const monthLabel = moment(month).format('MMMM YYYY');
            this.$monthSelect.append('<option value="' + month + '">' +  monthLabel + '</option>')
        });

        this.$monthSelect.val(this.selectedMonth);

        // check if date is outside events and set zero option
        const selectedMonthMoment = moment(this.selectedMonth).format('YYYY-MM');
        const startEventsDateMoment = moment(this.start_events_date).format('YYYY-MM');
        const endEventsDateMoment = moment(this.end_events_date).format('YYYY-MM');
        if(moment(selectedMonthMoment).diff(moment(endEventsDateMoment),'months')  > 0 || moment(selectedMonthMoment).diff(moment(startEventsDateMoment),'months') < 0) {
            this.$monthSelect.prepend('<option value="0">Välj månad</option>');
            this.$monthSelect.val(0);
        }
        if(!isTouchDev()) {
            this.$monthSelect.chosen({
                disable_search: true,
            });
            $('.chosen-search-input').attr('aria-label', 'search-input');
        }
    }

    moveLinePrev() {
        if(this.isMoving) return;
        const shift = this.$dayWidth * this.step;
        this._generatePrevDates();
        this.buildLine();
        this._increaseLine(shift);
        this.presetLinePosition(-shift);
        this._moveLine('right', 0);

    }

    moveLineNext() {
        if(this.isMoving) return;
        const shift = this.$dayWidth * this.step;
        this._generateNextDates();
        this.buildLine();
        this._increaseLine(shift);
        this._moveLine('left', -shift);
    }

    _increaseLine(width) {
        const newWidth = this.$line.width() + width;
        this.$line.css({width:newWidth});
    }

    _moveLine(dir,width){
        this.isMoving = true;
        this.$line.animate({
            left: width,
        }, 500, () => {
            this.removeDays(dir);
        });
    }

    removeDays(dir) {
        if(dir === 'left') {
            this.line.splice(0,this.step);
            this.buildLine();
            this.presetLinePosition(0);
        } else {
            this.line.splice((this.line.length) - this.step,this.step);
            this.buildLine();
        }
        this.resetLineWidth();
        this.isMoving = false;
    }

    presetLinePosition(leftPos) {
        this.$line.css({
            left: leftPos,
        })
    }

    resetLineWidth() {
        this.$line.css({
            width: this.$lineWidth,
        })
    }

    _sendDates() {
        const startDate = this.selectedDate.format('YYYY-MM-DD');
        this.isFetching = true;
        this._showNoEventsMessage(false);
        this._showLoading(true);
        $.ajax({
            type : "GET",
            dataType : "json",
            url: window.ajaxurl,
            data: ({
                action: 'event_calendar_list_action',
                start_date: startDate,
                end_date: this.end_events_date,
            }),
            success: (res)=>{
                this.$eventsListWrapper.empty();
                const responseEventsLength = res.events.length;

                // sort by start date
                this._sortEvents(res.events);

                if(responseEventsLength) {
                    this.events = res.events.filter(event=>!event.is_permanent);
                    this._showNoEventsMessage(false);
                    this._parseEvents();
                } else {
                    this.events = [];
                    this._showNoEventsMessage(true);
                }
                this.isFetching = false;
                this._showLoading(false);
            },
        });
    }

    _sortDates(dates) {
        return dates.sort((a,b)=>{
            const dateA = a ? a.replace(/-/g, '') : 0;
            const dateB = b ? b.replace(/-/g, '') : 0;
            return dateA - dateB
        });
    }

    _sortEvents(events) {
        return events.sort((a,b)=>{
            const dateA = a.date_start ? a.date_start.replace(/-/g, '') : 0;
            const dateB = b.date_start ? b.date_start.replace(/-/g, '') : 0;
            return dateA - dateB
        });
    }

    _getPermanentEvents() {
        $.ajax({
            type : "GET",
            dataType : "json",
            url: window.ajaxurl,
            data: ({
                action: 'permanent_events_list_action',
            }),
            success: (res)=>{
                if(res.events.length) {
                    this.permanentEvents = res.events;
                }
            },
            error: (error)=>{
                console.error(error);
            },
        });
    }

    _parseEvents() {
        let events = [];
        if(this.selectedCategory.name === 'all') {
            events = this.events.concat(this.permanentEvents);
        } else {
            events = this.events.concat(this.permanentEvents).filter(event=>event.category === this.selectedCategory.name || event.category.includes(this.selectedCategory.name));
        }

        // if this is home page show max 8 events
        if($('body').hasClass('home')) {
            if(events.length > 8) {
                events.splice(8, events.length-1);
            }
        }
        // show message if there are no events for selected category
        if(!events.length) {
            this._showNoEventsMessage(true)
        }

        events.forEach((event,index)=>{
            const cssClass = `item-${index}`;
            let eventDateContainer = '';

            if(!event.is_permanent) {
                eventDateContainer = event.date_start === event.date_end ?
                    `<div class="event-date">
                    <span class="event-date-start">${moment(event.date_start).format('D MMM')}</span>
                </div>` : `<div class="event-date">
                    <span class="event-date-start">${moment(event.date_start).format('D MMM')}</span>
                    <span class="event-date-separator">-</span>
                    <span class="event-date-end">${moment(event.date_end).format('D MMM')}</span>
                </div>`;
            }

            const $event = `<li class="event ${cssClass}">
                                <a title="${event.title}" class="event-link" href="${event.permalink}">
                                    <div class="photo-block" style='background-image: url("${event.thumbnail_url}")'>
                                    ${eventDateContainer}
                                    <div class="category-name">
                                        <i class="fa fa-info" aria-hidden="true"></i>
                                        <span class="text-el">${event.category}</span>
                                    </div>
                                    </div>
                                    <!--<img src="" alt="${event.title}">-->
                                    <div class="text-el">
                                        <h2 class="title">${event.title}</h2>
                                        <div class="description">${event.excerpt}</div>
                                    </div>
                                    
                                </a>
                            </li>`;
            this.$eventsListWrapper.append($event);
        });
    }

    _showNoEventsMessage(show) {
        if(show) { this.$noEventsMessage.removeClass('hide') } else { this.$noEventsMessage.addClass('hide') }
    }

    _showLoading(show) {
        if(show) { this.$loading.removeClass('hide') } else { this.$loading.addClass('hide') }
    }
}

export default () => {
    moment.locale('sv');
    const selectedDay = moment();
    const $mainWrapper = $('.js-calendar');
    const $prevButton = $mainWrapper.find('.js-prev');
    const $nextButton = $mainWrapper.find('.js-next');
    const $lineWrapper = $mainWrapper.find('.js-calendar-line');
    const $eventsListWrapper = $('.js-event-list');
    const $noEventsMessage = $('.js-no-events');
    const $loading = $('.js-loading');
    const $line = $lineWrapper.find('ul');
    const $monthSelect = $('.js-select-month');

    const dayWidth = 52; // set in css

    // init line
    let lineWidth = $lineWrapper.width();
    let qty = Math.floor(lineWidth/dayWidth);
    let step = Math.ceil(qty/3);
    // init calendar
    const homeCalendar = new Calendar(selectedDay,lineWidth,qty,$line,dayWidth,step,$monthSelect,$eventsListWrapper,$noEventsMessage,$loading);

    homeCalendar.init();

    // resize
    $(window).resize(()=>{
        lineWidth = $lineWrapper.width();
        qty = Math.floor(lineWidth/dayWidth);
        step = Math.floor(qty/3);
        homeCalendar.setLineWidth(lineWidth);
        homeCalendar.setQty(qty);
        homeCalendar.setStep(step);
        homeCalendar.generateInitDays();
        homeCalendar.buildLine();
    });

    $($prevButton).click(()=>{
        homeCalendar.moveLinePrev();
    });

    $($nextButton).click(()=>{
        homeCalendar.moveLineNext();
    });

    // select date
    $('body').on('click','.js-select-date',function(e){
        e.preventDefault();
        homeCalendar.setSelectedDate($(this).attr('data-date'));
    });
    // select month
    $('body').on('change','.js-select-month',function(){
        homeCalendar.selectMonth($(this).val())
    });

    // select tab
    $('body').on('click','.js-calendar-tab',function(){
        $('.js-calendar-tab').removeClass('selected');
        $(this).addClass('selected');
        homeCalendar.selectCategory({name:$(this).attr('data-name'), permanent: $(this).attr('data-permanent') === '1'})
    });

    // if url has a hash (category tab was selected)
    if(window.location.hash) {
        let hash = window.location.hash.replace(/%20/g," ");
        hash = hash.substr(1);
        const $selectedTab = $('.js-calendar-tab[data-name="' + decodeURI(hash) + '"]');
        homeCalendar.setCategory({name:decodeURI(hash), permanent: $selectedTab.attr('data-permanent') === '1'});
        $('.js-calendar-tab').removeClass('selected');
        $selectedTab.addClass('selected');
    }

    if(isTouchDev()) {
        $('.advance-search').find('select').addClass('touch-dev-search');
    }
};


// WEBPACK FOOTER //
// ./scripts/modules/calendar.js